import { REMOVE_FROM_USER_ADDRESS_BOOK_REQUEST, REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS, REMOVE_FROM_USER_ADDRESS_BOOK_ERROR } from '../types';
import { useHelper } from '../helpers';
export const removeFromUserAddressBookRequest = addressId => ({
  type: REMOVE_FROM_USER_ADDRESS_BOOK_REQUEST,
  payload: addressId
});
export const removeFromUserAddressBookSuccess = addressId => ({
  type: REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS,
  payload: {
    addressId
  }
});
export const removeFromUserAddressBookError = (addressId, error) => ({
  type: REMOVE_FROM_USER_ADDRESS_BOOK_ERROR,
  payload: {
    error,
    addressId
  },
  error: true
});
export const removeFromUserAddressBook = addressId => async (dispatch, getState, _ref) => {
  let {
    chord
  } = _ref;
  const {
    withAuth
  } = useHelper(dispatch, getState);
  dispatch(removeFromUserAddressBookRequest(addressId));
  try {
    const {
      user
    } = getState();
    const userId = user.data.id;
    await withAuth(chord.oms.removeFromUserAddressBook)(userId, addressId);
    dispatch(removeFromUserAddressBookSuccess(addressId));
  } catch (error) {
    dispatch(removeFromUserAddressBookError(addressId, error));
    throw error;
  }
};